/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_LinkInputs */

const en_tables_rule_sets_link = /** @type {(inputs: Tables_Rule_Sets_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Link`)
};

const de_tables_rule_sets_link = /** @type {(inputs: Tables_Rule_Sets_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link-Typ`)
};

/**
* | output |
* | --- |
* | "Sets Link" |
*
* @param {Tables_Rule_Sets_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_link = /** @type {((inputs?: Tables_Rule_Sets_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_link(inputs)
	return de_tables_rule_sets_link(inputs)
});